import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
export function useClientInvoices(customerId) {
    let { refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.ClientBillingOverview,
            customerId
        ],
        queryFn: ()=>api.invoice.getInvoicesByCustomer(customerId),
        enabled: customerId != null,
        refreshOnHookMount
    });
    const refetch = ()=>{
        void refresh({
            throwOnError: false
        });
    };
    if (customerId == null) {
        return {
            invoices: [],
            isLoading: false,
            isError: false,
            refetch
        };
    }
    return {
        invoices: data !== null && data !== void 0 ? data : [],
        isLoading,
        isError: error != null,
        refetch
    };
}
